import { render, staticRenderFns } from "./acceuil.vue?vue&type=template&id=27bb3e52&"
import script from "./acceuil.vue?vue&type=script&lang=js&"
export * from "./acceuil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports